/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

export enum Key { // all keys must be uppercase
  Alt = "ALT",
  Shift = "SHIFT",
  A = "A",
  Escape = "ESCAPE",
}

export enum KeyEventType {
  Up,
  Down,
}

export class KeyHandler {
  readonly key: Key;

  readonly callback: () => void;

  readonly type: KeyEventType;

  readonly spammable: boolean;

  constructor(key: Key, callback: () => void, type: KeyEventType, spammable = false) {
    this.key = key;
    this.callback = callback;
    this.type = type;
    this.spammable = spammable;
  }
}
